module.exports = __webpack_public_path__ + "static/media/demo3.bc127594.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/home/demo3.jpg
// module id = 698
// module chunks = 2